import React, { useState, useEffect } from 'react';


import moment from 'moment';
import "moment/locale/pt-br";
import { Calendar, momentLocalizer} from 'react-big-calendar'; 
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';


import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';




import {Link, Navigate, useParams} from 'react-router-dom';
import Navbar from '../Components/Navbar/navbar.jsx';
import './calendario.css';
import './eventosPadrao.jsx';
import firebase from '../Config/firebase.js';
import { collection, doc, addDoc, getDoc, getFirestore, getDocs, query, orderBy, setDoc, deleteDoc, Timestamp } from 'firebase/firestore';
import eventosPadrao from './eventosPadrao.jsx';
import EventModal from './ModalEvent/EventModal.jsx';
import Adicionar from './Adicionar/adicionar.jsx';
import CustomTollbar from './CustonCalendar/CustomTollbar.jsx';
import FiltroAtividades from './filtro/FiltroAtividades.jsx';

const DragAndDropCalendar = withDragAndDrop(Calendar);
const localizer = momentLocalizer(moment);

function Calendario (){

  const [eventos,setEventos] = useState([]);
  const [eventoSelecionado,seteventoSelecionado] = useState(null);
  const [eventosFiltrados, setEventosFiltrados] = useState([]);
  const [busca,setBusca] = useState([]);
  const [excluido,setExcluido] = useState([]);
  const db = getFirestore();

  const eventStyle = (event) => ({
        style: {
          backgroundColor: event.color,
        },
  })

  const moverEventos = (data) => {
        const { start, end} = data;
        const updateEvents = eventos.map((event) =>{
          if(event.id === data.event.id){

            const fetchData = async () => {
              let d1 = new Date(start);
              let d2 = new Date(end);
              let dataini = Timestamp.fromDate(d1);
              let datafin = Timestamp.fromDate(d2);
              const docRef = doc(db, 'agenda', data.event.id);
              const docSnap = await getDoc(docRef);
        
              if (docSnap.exists()) {
                 console.log("Dado do Documento:", docSnap.data().titulo);
                 const docRef = setDoc(doc(db, 'agenda', data.event.id),{
                     titulo: data.event.title,
                     inicio: dataini,
                     fim: datafin,
                     descricao: data.event.desc,
                     cor: data.event.color,
                     advogado: data.event.tipo
                             })
                             .then((docRef) => {
        
                             })
                             .catch((error) => {
         
                             })
              } else {
                // docSnap.data() will be undefined in this case
                console.log("Não encontrado!");
              }
            }
            fetchData();

            return{
              ...event,
              start: new Date(start),
              end: new Date(end)
            };
          }
          return event;  
        });
        setEventos(updateEvents)
      };

  const handleEventClick = (evento) =>{
    seteventoSelecionado(evento);
  }

  const handleEventClose = () =>{
    seteventoSelecionado(null);
  }

  const handleAdicionar = (novoEvento) => {
     let d1 = new Date(novoEvento.start);

     let d2 = new Date(novoEvento.end);
     // d2.setHours(d2.getHours() + 1);
     

     let dataini = Timestamp.fromDate(d1);
     let datafin = Timestamp.fromDate(d2);
   
     console.log('dataini:',dataini);
     console.log('datafin:',datafin);
     console.log('novo:',novoEvento.end);

     const docRef = addDoc(collection(db, "agenda"), {
      titulo: novoEvento.title,
      inicio: dataini,
      fim: datafin,
      descricao: novoEvento.desc,
      cor: novoEvento.color,
      advogado: novoEvento.tipo
    })
    .then((docRef) => {
      let eventosPadrao = [];
      const fetchData = async () => {
        const db = getFirestore();
        const clientesRef = collection(db, 'agenda');
        const q = query(clientesRef, orderBy('advogado'));
         const snapshot = await getDocs(q);
        
        snapshot.forEach((doc) => {
          if (doc.data().advogado.indexOf(busca) >= 0){
           eventosPadrao.push({
            id: doc.id,
            title: doc.data().titulo,
            start: doc.data().inicio.toDate(),
            end: doc.data().fim.toDate(),
            desc: doc.data().descricao,
            color: doc.data().cor,
            tipo: doc.data().advogado
           })
          }
        });
        setEventos(eventosPadrao);
        setEventosFiltrados(eventosPadrao);
        console.log('ok ',eventosPadrao);
      };
    
      fetchData();
    })
    .catch((error) => {

    })
    
  }

  const handleEventDelete= (eventId) =>{
    //Logica do banco
   const updatedEvents = eventos.filter((event) => event.id !== eventId)
   const db = getFirestore();
       deleteDoc(doc(db,'agenda',eventId)).then(()=>{
        setEventos(updatedEvents);
        seteventoSelecionado(null);
       })

};

const handleEventUpdate = (updatedEvent) =>{
    //Logica do banco
    const fetchData = async () => {
      let d1 = new Date(updatedEvent.start);
      let d2 = new Date(updatedEvent.end);
      let dataini = Timestamp.fromDate(d1);
      let datafin = Timestamp.fromDate(d2);
      const docRef = doc(db, 'agenda', updatedEvent.id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
         console.log("Dado do Documento:", docSnap.data().titulo);
         const docRef = setDoc(doc(db, 'agenda', updatedEvent.id),{
             titulo: updatedEvent.title,
             inicio: dataini,
             fim: datafin,
             descricao: updatedEvent.desc,
             cor: updatedEvent.color,
             advogado: updatedEvent.tipo
                     })
                     .then((docRef) => {

                     })
                     .catch((error) => {
 
                     })
      } else {
        // docSnap.data() will be undefined in this case
        console.log("Não encontrado!");
      }
    }
    fetchData();

   const updatedEvents = eventos.map((event) =>{
       if(event.id === updatedEvent.id){
           return updatedEvent;
       }
       return event;
   });
   setEventos(updatedEvents);
   seteventoSelecionado(null);
}

const handleSelecionarAtividades = (atividadesSelecionadas) =>{
  setEventosFiltrados(atividadesSelecionadas);
}

useEffect(() => {
        let eventosPadrao = [];
        const fetchData = async () => {
          const db = getFirestore();
          const clientesRef = collection(db, 'agenda');
          const q = query(clientesRef, orderBy('advogado'));
           const snapshot = await getDocs(q);
          
          snapshot.forEach((doc) => {
            if (doc.data().advogado.indexOf(busca) >= 0){
             eventosPadrao.push({
              id: doc.id,
              title: doc.data().titulo,
              start: doc.data().inicio.toDate(),
              end: doc.data().fim.toDate(),
              desc: doc.data().descricao,
              color: doc.data().cor,
              tipo: doc.data().advogado
             })
            }
          });
          setEventos(eventosPadrao);
          setEventosFiltrados(eventosPadrao);
          console.log('ok ',eventosPadrao);
        };
      
        fetchData();
    }, [busca,excluido]);

return<div>
    <Navbar/>
    <div className='tela'>
    <div className='toolbar p-4' style={{maxHeight:'100vh', overflowY:'auto'}}>
         <Adicionar onAdicionar={handleAdicionar}/>
         <FiltroAtividades atividades={eventos} onSelecionarAtividades={handleSelecionarAtividades}/>
    </div>
    <div className='calendario'>
      <DragAndDropCalendar
       defaultDate={moment().toDate()}
       defaultView='week'
       events={eventosFiltrados}
       localizer={localizer}
       resizable
       onEventDrop={moverEventos}
       onEventResize={moverEventos}
       onSelectEvent={handleEventClick}
       eventPropGetter={eventStyle}
       components={{
        toolbar: CustomTollbar,
       }}
       className='calendar'
      />
      {eventoSelecionado && (
        <EventModal
         evento = {eventoSelecionado}
         onClose = {handleEventClose}
         onDelete={handleEventDelete} 
         onUpdate={handleEventUpdate}
         />
      )}
    </div>
    </div>
</div>

}


export default Calendario;
